export interface IHppPayload {
    paymentIntentId: string;
    saveCard: boolean;
}

export const mapHppPayload = (paymentIntentId: string, wouldSaveCard: boolean): IHppPayload => ({
    paymentIntentId,
    saveCard: wouldSaveCard,
});
